import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { TooltipProps } from "recharts";
import { ICustomPayload } from "src/components/Charts/models/interfaces";
import { chartType, CustomTooltipLineProps } from "src/pages/Insights/models/interfaces";
import { chartStyleConfigLine, formatValue, renderNValueLabel } from "src/pages/Insights/transformer";
import { RootState } from "src/store";
import { CustomMarkerTooltip } from "../CustomMarker";

export const CustomTooltip: React.FC<CustomTooltipLineProps> = ({
	active,
	payload,
	chartDataTooltip,
	graphCustomization,
	setIsTooltipHovered,
	type,
	obj,
	config,
	chartTypeTooltip,
	hoveredBarKey,
	customConfig
}) => {
	const { selectedChart } = useSelector((state: RootState) => state.sectionalSummarySlice.sectionalSummary);

	const nSize = useRef(null);

	function areAllValuesEqual(obj: Record<string, any>): boolean {
		const entries = Object.entries(obj).filter(([key]) => key !== "name");

		if (entries.length === 0) return true;

		const firstValue = entries[0][1];
		if (entries.every(([_, value]) => value === firstValue)) {
			const parsed = renderNValueLabel(firstValue);
			// nSize.current = firstValue;
			nSize.current = parsed;
		}

		return entries.every(([_, value]) => value === firstValue);
	}

	// const labelOrder = obj?.chartData?.[0] && Object.keys(obj?.chartData?.[0]).filter((key) => key !== "name");

	// const labelOrderIndex =
	// 	Array.isArray(labelOrder) &&
	// 	labelOrder.reduce((acc, label, i) => {
	// 		acc[label] = i;
	// 		return acc;
	// 	}, {});

	if (active && payload && payload?.length && hoveredBarKey) {
		// let sortedPayload = payload.sort((a, b) => {
		// 	const labelA = obj?.chartData?.[0]?.[a.dataKey];
		// 	const labelB = obj?.chartData?.[0]?.[b.dataKey];
		// 	if (config?.layout === "horizontal" && config?.stackId) {
		// 		return labelOrderIndex[labelB] - labelOrderIndex[labelA];
		// 	}
		// 	return labelOrderIndex[labelA] - labelOrderIndex[labelB];
		// });
		let sortedPayload = payload;

		if (config?.layout === "horizontal" && config?.stackId && chartTypeTooltip?.toLocaleLowerCase() === chartType.Bar?.toLocaleLowerCase()) {
			sortedPayload = [...sortedPayload]?.reverse();
		}

		//Add logic to filter only hovered series
		if (hoveredBarKey && Array.isArray(sortedPayload)) {
			sortedPayload = sortedPayload.filter((item) => item.dataKey === hoveredBarKey);
		}

		return (
			<div
				style={{
					backgroundColor: customConfig?.tooltip?.background_color,
					fontSize: customConfig?.tooltip?.font_size,
					fontFamily: customConfig?.tooltip?.font_family,
					padding: customConfig?.tooltip?.padding,
					borderRadius: customConfig?.tooltip?.border_radius,
					boxShadow: customConfig?.tooltip?.box_shadow,
					whiteSpace: customConfig?.tooltip?.white_space,
					zIndex: customConfig?.tooltip?.z_index,
					maxWidth: customConfig?.tooltip?.max_width,
					pointerEvents: customConfig?.tooltip?.pointer_events // <== THIS IS IMPORTANT
				}}
				onMouseEnter={() => setIsTooltipHovered(true)}
				onMouseLeave={() => setIsTooltipHovered(false)}>
				<h4 style={{ marginBottom: 10 }}>
					{/* {payload[0]?.payload?.name} {" " + nSize.current && nSize.current !== undefined ? "(" + nSize.current + ")" : ""} */}
					{payload[0]?.payload?.name}{" "}
					{/* {" " + nSize.current && nSize.current !== undefined && nSize?.current?.labelParts?.length > 0 ? (
						<>
							{"("}
							{nSize?.current?.labelParts?.map((part, idx) => (
								<span key={idx} style={{ color: part?.color }}>
									{part.text}
								</span>
							))}
							{")"}
						</>
					) : (
						""
					)} */}
				</h4>
				<div
					style={{
						maxHeight: 300, // Restrict height for scroll
						overflowY: "auto",
						overscrollBehavior: "contain",
						...(!selectedChart && { maxHeight: 250 }), // conditionally add maxHeight
					}}>
					<ul style={{ padding: 0, listStyleType: "none", margin: 0 }}>
						{sortedPayload?.map((item, index) => {
							{
								/* {payload?.map((item, index) => { */
							}
							const customItem = item as ICustomPayload;
							const format = graphCustomization?.dlabel_fmt || "##";
							const formattedValues = formatValue(Number(customItem?.value), format);
							const d = chartDataTooltip?.find((i) => i?.name === item?.payload?.name);
							const parsed = renderNValueLabel(d?.[customItem?.name]);

							return (
								<li key={index} style={{ marginBottom: "4px", color: item.color }}>
									{/* {!graphCustomization?.line_chart_markers?.[customItem?.name] ? ( */}
									{type === "default" ? (
										<span
											style={{
												display: "inline-block",
												width: "10px",
												height: "10px",
												backgroundColor: item.color,
												borderRadius: "50%",
												marginRight: "8px",
											}}
										/>
									) : (
										// <div>circle</div>
										<CustomMarkerTooltip
											markerType={graphCustomization?.line_chart_markers?.[customItem?.name]}
											markerSize={graphCustomization?.line_marker_size?.[customItem?.name]}
											// cx={0} // Explicit x-coordinate
											// cy={0} // Explicit y-coordinate
											stroke={item?.color || "#000"} // Color for the marker
										/>
									)}
									{customItem?.name === "" ? "[Blank]" : customItem?.name}: {formattedValues}
									{/* {d && !areAllValuesEqual(d) && ` (${d?.[customItem?.name]})`} */}
									{d && !areAllValuesEqual(d) && (
										<>
											{" ("}
											{parsed?.labelParts?.map((part, idx) => (
												<tspan key={idx} style={{ color: part?.color }}>
													{part.text}
												</tspan>
											))}
											{")"}
										</>
									)}
								</li>
							);
						})}
					</ul>
				</div>
			</div>

			// <div
			// 	style={{
			// 		backgroundColor: "white",
			// 		fontSize: 12,
			// 		fontFamily: "Open Sans",
			// 		padding: "10px",
			// 		borderRadius: "8px",
			// 		boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
			// 		whiteSpace: "normal",
			// 		// wordBreak: "break-word",
			// 		zIndex: 9999,
			// 		maxWidth: 400,
			// 		maxHeight: 400,
			// 		overflow: "auto",
			// 	}}>
			// 	<h4 style={{ marginBottom: 10 }}>{payload[0].payload?.name}</h4>
			// 	<div
			// 		style={{
			// 			overflowY: "auto",
			// 			overscrollBehavior: "contain",
			// 		}}>
			// 		<ul style={{ padding: 0, listStyleType: "none" }}>
			// 			{payload.map((item, index) => {
			// 				const customItem = item as ICustomPayload;
			// 				const format = graphCustomization?.dlabel_fmt || "##";
			// 				const formattedValues = formatValue(Number(customItem?.value), format);
			// 				const d = chartDataTooltip?.find((i) => i?.name === item?.payload?.name);

			// 				return (
			// 					<li key={index} style={{ marginBottom: "4px", color: item.color }}>
			// 						<span
			// 							style={{
			// 								display: "inline-block",
			// 								width: "10px",
			// 								height: "10px",
			// 								backgroundColor: item.color,
			// 								borderRadius: "50%",
			// 								marginRight: "8px",
			// 							}}
			// 						/>
			// 						{customItem?.name}: {formattedValues}
			// 						{d && ` (${d?.[customItem?.name]})`}
			// 					</li>
			// 				);
			// 			})}
			// 		</ul>
			// 	</div>
			// </div>
		);
	}
	return null;
};
